import { create } from 'zustand';
import { message } from 'antd';
import axiosInstance from '../utils/axiosInstance';
import { getCachedData, setCachedData, clearCacheByKey } from '../utils/cacheUtil';

const useBillStore = create((set) => ({
  bills: [],
  loading: false,
  error: null,

  fetchBills: async (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    const cacheKey = `bills-${queryParams}`;
    
    const cached = getCachedData(cacheKey);
    if (cached) {
      set({ bills: cached, loading: false, error: null });
      return;
    }

    set({ loading: true });
    try {
      const response = await axiosInstance.get(`/bills/${queryParams ? `?${queryParams}` : ''}`);
      setCachedData(cacheKey, response.data);
      set({ 
        bills: response.data,
        loading: false,
        error: null 
      });
    } catch (error) {
      set({ error: error.message, loading: false });
      message.error('Failed to fetch bills');
    }
  },

  createBill: async (billData) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.post('/bills/', billData);
      clearCacheByKey('bills');
      set(state => ({
        bills: [...state.bills, response.data],
        loading: false,
      }));
      message.success('Bill created successfully');
      return { success: true, data: response.data };
    } catch (error) {
      set({ loading: false });
      message.error('Failed to create bill');
      return { success: false, error };
    }
  },

  updateBill: async (id, billData) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.put(`/bills/${id}/`, billData);
      clearCacheByKey('bills');
      set(state => ({
        bills: state.bills.map(bill => 
          bill.id === id ? response.data : bill
        ),
        loading: false,
      }));
      message.success('Bill updated successfully');
      return { success: true, data: response.data };
    } catch (error) {
      set({ loading: false });
      message.error('Failed to update bill');
      return { success: false, error };
    }
  },

  deleteBill: async (id) => {
    try {
      await axiosInstance.delete(`/bills/${id}/`);
      clearCacheByKey('bills');
      set(state => ({
        bills: state.bills.filter(bill => bill.id !== id),
      }));
      message.success('Bill deleted successfully');
      return { success: true };
    } catch (error) {
      message.error('Failed to delete bill');
      return { success: false, error };
    }
  },
}));

export default useBillStore;
